var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mb-2" }, [
    _c(
      "div",
      { staticClass: "col-4" },
      [
        _vm.label
          ? [
              _c(
                "label",
                { staticClass: "control-label", attrs: { for: _vm.id } },
                [_vm._v(_vm._s(_vm.label))]
              )
            ]
          : [_vm._t("label", null, { id: _vm.id })]
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-8" },
      [
        _vm.hasIcon
          ? _c(
              "input-group",
              { attrs: { icon: _vm.icon } },
              [_vm._t("input", null, { id: _vm.id })],
              2
            )
          : _vm._t("input", null, { id: _vm.id })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "offset-4 col-8" }, [_vm._t("errors")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }